module.exports = __webpack_public_path__ + "static/media/pla_vel_mov.8e5f082d.png";